export const LOGO_ICON = "https://customer-assets.emergentagent.com/job_affiliate-stats/artifacts/jtsf42g8_icon.svg";
export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_affiliate-stats/artifacts/cu5lekm3_Xlent%20logo%201.svg";
export const LOGO_NAVY = "https://customer-assets.emergentagent.com/job_affiliate-stats/artifacts/fe05hwag_xlent%20logo%202.svg";
